/**
 * 手机号展示脱敏（唯一实现）
 * -----------------------------------------------------------------------------
 * 收件人电话、发码成功提示都要「前 3 后 4、中间打星」，两处各写一遍必然漂移。
 *
 * ⚠️ 太短的串**原样返回**：这一步的目的是少露信息，不是把号码变成 `***`。
 * 串本身已经不满 7 位时（脏数据 / 输入中途），按位截取会连着把用户能用来
 * 辨认的几位也吃掉，反而更难核对。
 */
export function maskPhone(phone: string): string {
  const trimmed = phone.trim();
  if (trimmed.length < 7) return trimmed;
  return `${trimmed.slice(0, 3)}****${trimmed.slice(-4)}`;
}
